export default "__VITE_ASSET__1c6c5524__"